module.exports = __webpack_public_path__ + "img/ics_f_plus_circle.eff5eae1.svg";